/* eslint-disable import/no-unresolved */
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { Card, Container } from '@material-ui/core';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
import { COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD, CAMPAIGN_RULE_SET_LIST_HEAD } from 'src/constants/Dashboard';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getCampaignRuleData } from 'src/redux/slices/campaignrules';
import CollapsableTableCampaignRule from './CampaignRuleTable';

export default function CampaignRuleMaster() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCampaignRuleData());
  }, [dispatch]);

  return (
    <Page title="Campaign Rule Set | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Campaign Rule"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Campaign Rule', href: PATH_DASHBOARD.general.campaign_rule }
          ]}
        />
        <Card>
          <CollapsableTableCampaignRule
            tableHead={CAMPAIGN_RULE_SET_LIST_HEAD}
            collapsableTableHead={COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD}
          />
        </Card>
      </Container>
    </Page>
  );
}
